/**
 * Turns a stored file key/path (as returned by the server's file-resolution
 * helpers) into a URL the browser can actually load — every upload is
 * served through the authenticated /api/files/* proxy, whether it lives in
 * S3 or on local disk, so the stored value alone is never a loadable URL.
 * @param path
 */
export function toFileUrl(path: string | null | undefined): string | null {
  return path ? `/api/files/${path}` : null;
}
